import { render, staticRenderFns } from "./ShopPage.vue?vue&type=template&id=0b892420&scoped=true"
import script from "./ShopPage.vue?vue&type=script&lang=js"
export * from "./ShopPage.vue?vue&type=script&lang=js"
import style0 from "./ShopPage.vue?vue&type=style&index=0&id=0b892420&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b892420",
  null
  
)

export default component.exports